import { setGetProviderByIdAction } from '../action';
import { getProviderById } from '../api/getProviderById';

export const setGetProviderById = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getProviderById(params);

            dispatch(setGetProviderByIdAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}